import cs from "classnames";
import React from "react";
import classes from "./loader.module.scss";

interface Props {
  showFullPage?: boolean;
  wrapperClassName?: string;
  loaderClassName?: string;
}

const Loader: React.FC<Props> = ({
  showFullPage = true,
  loaderClassName = "",
  wrapperClassName = "",
}) => {
  return (
    <div
      className={cs(classes.loaderWrapper, {
        [classes.fullPageWrapper]: showFullPage,
        [wrapperClassName]: !!wrapperClassName,
      })}
    >
      <div
        className={cs(classes.loader, {
          [loaderClassName]: !!loaderClassName,
        })}
      ></div>
    </div>
  );
};

export default Loader;
